import Backbone from "backbone";
import $ from "jquery";
import * as _ from "underscore";

import * as chromeExtensionInstaller from "chromeExtensionInstaller";
import * as modalDialog from "modalDialog";
import * as mustcache from "mustcache";
import readlangClient from "readlangClient";
import * as languageMap from "shared/languageMap";
import * as webReaderInstaller from "webReaderInstaller";

const PopularDomainsView = Backbone.View.extend({
  initialize: function (options) {
    this.options = options;
    this.models = options.models;

    readlangClient.request(
      "GET",
      "/api/popularDomains",
      {
        language: this.models.user.get("currentLearningLanguage"),
        limit: 50,
      },
      (data) => {
        this.popularDomains = data;
        this.render();
      }
    );
  },
  render: function () {
    const templateData = {
      popularDomains: this.popularDomains,
      popularDomainsExist: this.popularDomains.length > 0,
      currentLearningLanguageString:
        languageMap.map[this.models.user.get("currentLearningLanguage")].name,
      currentLearningLanguageEnglishString:
        languageMap.map[this.models.user.get("currentLearningLanguage")]
          .english,
      // cspell: disable-next-line
      chrome: window.chrome && window.chrome.webstore,
      prominentWebReaderCallout: webReaderInstaller.showInstaller(),
      spanish: this.models.user.get("currentLearningLanguage") === "es",
    };

    if (this.models.user.isGod()) {
      // number the approved domains
      let index = 0;
      _.each(templateData.popularDomains, (domain) => {
        if (domain.approved) {
          index++;
          domain.title = String(index) + " " + domain.title;
        }
      });
    }

    mustcache.render("popularDomains", templateData, (html) => {
      this.$el.html(html);
      this.delegateEvents(this.events);
      this.options.renderedCallback();
    });
  },
  events: {
    "click #installChromeExtension": "installChromeExtension",
    "click #installWebReaderBookmarklet": "installWebReaderBookmarklet",
    "click .approve": "approveDomain",
    "click .popularDomainLink": "openPopularDomainLink",
  },
  installChromeExtension: function (event) {
    event.stopPropagation();
    event.preventDefault();

    chromeExtensionInstaller.install();
  },
  installWebReaderBookmarklet: function (event) {
    event.stopPropagation();
    event.preventDefault();

    const dialog = $('<div class="centralDialog"></div>').append(
      '<h2>Install Web Reader</h2><br/><div class="webReaderInstaller"></div>'
    );
    webReaderInstaller.render(dialog.find(".webReaderInstaller"));
    modalDialog.show(dialog);
  },
  approveDomain: function (event) {
    event.stopPropagation();
    event.preventDefault();

    const domainId = $(event.currentTarget).attr("data-domainId");

    readlangClient.request(
      "PATCH",
      "/api/domainInfo/" + domainId,
      { approved: true },
      (response) => {
        if (response.success) {
          _.findWhere(this.popularDomains, { _id: domainId }).approved = true;
          this.render();
        } else {
          alert("Error: " + response);
        }
      }
    );
  },
  openPopularDomainLink: function () {
    // XXX Outdated? Remove??
    top.postMessage(
      JSON.stringify({
        message: "backgroundPageMessage",
        data: {
          message: "webReaderLoaded",
        },
      }),
      "*"
    );
  },
});

export default PopularDomainsView;
